import { render } from "./TheMenuUser.vue?vue&type=template&id=7a5fcbb5"
import script from "./TheMenuUser.vue?vue&type=script&lang=ts"
export * from "./TheMenuUser.vue?vue&type=script&lang=ts"
script.render = render

export default script